export default function Navbar (){
    return(
        <>
        <div className="flex flex-row min-h-screen justify-center items-center">
        <video className="w-20" src="/logo-animation.mp4" autoPlay loop muted />
          <a className="text-[50px] font-loud" href="/">THE CONSOOMER</a>
        </div>
        </>
    )
}